module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch"
  }, [_c('span', {
    staticClass: "switch-label",
    class: {
      'active': _vm.checkValue(1)
    },
    on: {
      "click": function($event) {
        return _vm.setValue(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.val1))]), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    class: {
      'active': _vm.checkValue(2)
    },
    on: {
      "click": function($event) {
        return _vm.setValue(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.val2))]), _vm._v(" "), _c('span', {
    staticClass: "switch-selection",
    class: {
      'value-right': _vm.checkValue(2)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-808ab164!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ToggleYear.vue
// module id = 2046
// module chunks = 1